/** True when the JWT's `exp` has passed. Unreadable tokens count as live - the server decides. */
export function isJwtExpired(jwt: string, now = Date.now()): boolean {
  try {
    const payload = JSON.parse(atob(jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 <= now;
  } catch {
    return false;
  }
}
